import { render, staticRenderFns } from "./_UserProfile.vue?vue&type=template&id=6cdca696&"
import script from "./_UserProfile.vue?vue&type=script&lang=ts&"
export * from "./_UserProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports